// src/rds_ui/components/common/StatusBadge.jsx
// Thin wrapper — real implementation in shared/ui/StatusBadge.jsx
// (map: "rds", see shared/ui/statusMaps.js's `rdsStatusMap`/`rdsAnimatedStatuses`).
import StatusBadge from "../../../shared/ui/StatusBadge";
import { rdsAnimatedStatuses } from "../../../shared/ui/statusMaps";

export default function RdsStatusBadge({ status, size = "sm", pulse = false }) {
  const shouldPulse = pulse && rdsAnimatedStatuses.has(status);
  return <StatusBadge map="rds" status={status} size={size === "lg" ? "lg" : "sm"} pulse={shouldPulse} />;
}
